import { BaseModel } from '~/models/base-model';
import type { ContactUsMessageRequest } from '~/types';

export class ContactFormModel extends BaseModel<ContactUsMessageRequest> {
    recipient = '';
    fromEmail = '';
    fromName = '';
    message = '';
    subject = '';
    phone = null;
}
